import React, { useEffect, useState } from 'react';
import { Modal, Button, Box } from 'edenred-ui';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { ErrorPopupProps } from '@epi-models/components/ErrorPopup';

import { ErrorDetails } from '../../containers/ErrorData/ErrorDetails';
import { getErrorPopup } from '../../selectors/overlays';
import * as profileActions from '../../actions/profile';

const ErrorPopup = ({ errorPopup }: ErrorPopupProps) => {
  const { t } = useTranslation();
  const { sizeMedium, sizeLarge } = useTheme();
  const [open, setOpen] = useState(errorPopup.display);

  useEffect(() => {
    setOpen(errorPopup.display);
  }, [errorPopup.display]);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box fontSize={sizeLarge}>{t('components.error_popup.title')}</Box>
      <Box mt={2} mb={2} fontSize={sizeMedium}>
        {t('components.error_popup.message')}
        {errorPopup.showDetails && errorPopup.error && (
          <ErrorDetails error={errorPopup.error} />
        )}
      </Box>
      {errorPopup.closable ? (
        <Button id="error-modal-close-btn" onClick={() => setOpen(false)}>
          {t('components.error_popup.close_button')}
        </Button>
      ) : null}
    </Modal>
  );
};

const mapStateToProps = state => ({
  errorPopup: getErrorPopup(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(profileActions, dispatch);

const ConnectedErrorPopup = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorPopup);

export { ConnectedErrorPopup as ErrorPopup };
